import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { showToast, ToastMessage } from '../../Shared/ToastMessage';
import { baseUrl } from '../../../api/common';
import CKEditor from "react-ckeditor-component";

const MembershipPackage = ({ fetchMembershipPackageData, addPopupStatus, handleAddPopup, eventType, updateData }) => {

  const [updateId, setUpdateId] = useState("");

  const [formValues, setFormValues] = useState({
    application_name: "",
    fee: "",
    processing_fee: "",
    currency_type: "",
    gst_type: "",
    gst: "",
    description: "",
    documents_description: ""
  });

  const [errors, setErrors] = useState({
    applicationName: "",
    fee: "",
    currencyType: "",
    gstType: "",
    gst: "",
    description: "",
    documentsDescription: ""
  });

  const [currencyData, setCurrencyData] = useState([]);
  const [gstTypeData, setGstTypeData] = useState([]);
  const [gstData, setGstData] = useState([]);
  const [filteredGstValues, setFilteredGstValues] = useState([]);

  useEffect(() => {
    fetchCurrencyData();
    fetchGstTypeData();
    fetchGstData();
  }, []);

  useEffect(() => {
    if (formValues.gst_type && gstData.length > 0) {
      const filtered = gstData.filter((data) => `${data.gst_type}` === `${formValues.gst_type}`);
      setFilteredGstValues(filtered);
    } else {
      setFilteredGstValues([]);
    }
  }, [formValues.gst_type, gstData]);

  useEffect(() => {
    if (eventType === "Update" && updateData) {
      setUpdateId(updateData.id);
      setFormValues({
        application_name: updateData.application_name || '',
        fee: updateData.fee || '',
        processing_fee: updateData.processing_fee || '',
        currency_type: updateData.currency_type || '',
        gst_type: updateData.gst_type || '',
        gst: updateData.gst || '',
        description: updateData.description || '',
        documents_description: updateData.documents_description || ''
      });
    } else {
      setErrors({
        applicationName: "",
        fee: "",
        currencyType: "",
        gstType: "",
        gst: "",
        description: "",
        documentsDescription: ""
      });
      setFormValues({
        application_name: "",
        fee: "",
        processing_fee: "",
        currency_type: "",
        gst_type: "",
        gst: "",
        description: "",
        documents_description: ""
      });
    }
  }, [eventType, updateData, addPopupStatus, gstData]);

  const handleDescriptionChange = (event) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      description: event.editor.getData()
    }));
  };

  const handleDocumentsDescriptionChange = (event) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      documents_description: event.editor.getData()
    }));
  };

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  const validate = () => {
    const newErrors = {
      applicationName: "",
      fee: "",
      currencyType: "",
      gstType: "",
      gst: "",
      description: "",
      documentsDescription: ""
    };
    if (!formValues.application_name.trim()) {
      newErrors.applicationName = 'Application name cannot be empty';
    }
    // if (!formValues.fee.trim()) {
    //   newErrors.fee = 'Membership fee cannot be empty';
    // }
    if (formValues.fee.trim() && !formValues.currency_type) {
      newErrors.currencyType = 'Currency type cannot be empty';
    }
    // if (!formValues.processing_fee&&!formValues.gst_type) {
    //   newErrors.gstType = 'Gst type cannot be empty';
    // }
    if (formValues.gst_type && !formValues.gst) {
      newErrors.gst = 'Gst cannot be empty';
    }
    // if (!formValues.description.trim()) {
    //   newErrors.description = 'Membership description cannot be empty';
    // }
    // if (!formValues.documents_description.trim()) {
    //   newErrors.documentsDescription = 'Documents description cannot be empty';
    // }
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };

  const clearInputValues = () => {
    setErrors({
      applicationName: "",
      fee: "",
      currencyType: "",
      gstType: "",
      gst: "",
      description: "",
      documentsDescription: ""
    });
    setFormValues({
      application_name: "",
      fee: "",
      processing_fee: "",
      currency_type: "",
      gst_type: "",
      gst: "",
      description: "",
      documents_description: ""
    });
    handleAddPopup(false);
  };

  const addUpdateMembershipPackage = async () => {
    if (validate()) {
      console.log('Post Data:', formValues);
      try {
        const requestData = {
          ...formValues,
          ...(eventType === "Update" && { id: updateId }),
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(
          `${baseUrl}/api/add_application`,
          requestData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );
        if (response.data.status) {
          showToast(response.data.message, 'success');
          fetchMembershipPackageData();
          clearInputValues();
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("Submission failed. Please try again.", "error");
      }
    }
  };

  const fetchCurrencyData = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/get_currency`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('access_token'),
          },
        }
      );

      if (response.data.status) {
        setCurrencyData(response.data.data);
      } else {
        console.error('Error: Failed to fetch user data');
      }
    } catch (error) {
      console.error('Error fetching users data:', error);
    }
  };

  const fetchGstTypeData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_gst_type`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });

      if (response.data.status) {
        setGstTypeData(response.data.data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const fetchGstData = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/get_gst`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: localStorage.getItem('access_token'),
          },
        }
      );

      if (response.data.status) {
        setGstData(response.data.data);
      } else {
        console.error('Error: Failed to fetch user data');
      }
    } catch (error) {
      console.error('Error fetching users data:', error);
    }
  };

  return (
    <>
      <ToastMessage />
      {addPopupStatus && (
        <div className="extraspace_search_div search_div open">
          <div className="card member_master_sidebar_scrool">
            <div className="member_edit_pop_flex mb-3 text-end">
              <h3>{eventType} Membership Package</h3>
              <div className="input-group-append">
                <span onClick={() => handleAddPopup(false)} className="search_toggle btn btn-danger"><i className="fa fa-times"></i></span>
              </div>
            </div>
            <div className="table-responsive">
              <div className="body  application_body_side">
                <div className="row">
                  <div className="row ">
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>Application Name   <span className="text-danger">*</span></label>
                        <input
                          type="text"
                          className={`form-control ${errors.applicationName ? "red_border" : ''}`}
                          value={formValues.application_name}
                          onChange={(e) => handleInputChange('application_name', e.target.value)}

                        />
                        {errors && (
                          <p className="text-danger pos_abos">{errors.applicationName}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Membership Fee</label>
                        <input
                          type="number"
                          className={`form-control ${errors.fee ? "red_border" : ''}`}
                          value={formValues.fee}
                          onChange={(e) => handleInputChange('fee', e.target.value)}

                        />
                        {/* {errors && (
                          <p className="text-danger pos_abos">{errors.fee}</p>
                        )} */}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <label>Currency Type</label>
                      <div className="multiselect_div">
                        <select
                          className={`form-control ${errors.currencyType ? "red_border" : ""}`}
                          value={formValues.currency_type}
                          onChange={(e) => handleInputChange("currency_type", e.target.value)}
                          displayEmpty
                        >
                          <option value="">-- Select Currency Type--</option>
                          {currencyData.length > 0 ? (
                            currencyData.map((data) => (
                              <option key={data.id} value={data.id.toString()}>
                                {data.currency_name}
                              </option>
                            ))
                          ) : (
                            <option disabled>No data available</option>
                          )}
                        </select>
                        {errors && (
                          <p className="text-danger pos_abos">{errors.currencyType}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>GST Type</label>
                        <div className="multiselect_div">
                          <select
                            className={`multiselect multiselect-custom form-control ${errors.gstType ? "red_border" : ""}`}
                            value={formValues.gst_type}
                            onChange={(e) => handleInputChange("gst_type", e.target.value)}
                            displayEmpty
                          >
                            <option value="">-- Select Gst Type--</option>
                            {gstTypeData.length > 0 ? (
                              gstTypeData.map((data) => (
                                <option key={data.id} value={data.id.toString()}>
                                  {data.gst_type_name}
                                </option>
                              ))
                            ) : (
                              <option disabled>No data available</option>
                            )}
                          </select>
                          {/* {errors && (
                            <p className="text-danger pos_abos">{errors.gstType}</p>
                          )} */}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>GST (%)</label>
                        <div className="multiselect_div">
                          <select
                            className={`multiselect multiselect-custom form-control ${errors.gst ? "red_border" : ""}`}
                            disabled={!formValues.gst_type}
                            value={formValues.gst}
                            onChange={(e) => handleInputChange("gst", e.target.value)}
                            displayEmpty
                          >
                            <option value="">-- Select Gst --</option>
                            {filteredGstValues.length > 0 ? (
                              filteredGstValues.map((data) => (
                                // <option key={data.id} value={data.id.toString()}>
                                <option key={data.id} value={data.id}>
                                  {data.gst_value}
                                </option>
                              ))
                            ) : (
                              <option disabled>No data available</option>
                            )}
                          </select>
                          {errors && (
                            <p className="text-danger pos_abos">{errors.gst}</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Processing Fee (%)</label>
                        <input
                          type="number"
                          className={`form-control`}
                          value={formValues.processing_fee}
                          onChange={(e) => handleInputChange('processing_fee', e.target.value)}

                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='pb-3'>
                        <label>Membership Description</label>
                        <CKEditor data={formValues.description} activeClass="p10" content={formValues.description} events={{ change: handleDescriptionChange }} />
                        {errors && (
                          <p className="text-danger pos_abos">{errors.description}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className='pb-3'>
                        <label>Documents Description</label>
                        <CKEditor activeClass="p10" content={formValues.documents_description} events={{ change: handleDocumentsDescriptionChange }} />
                        {errors && (
                          <p className="text-danger pos_abos">{errors.documentsDescription}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12 p-3">
                      <div className='member_button_flex'>
                        <button onClick={() => addUpdateMembershipPackage()} className="btn btn-outline-info">{eventType}</button>
                        <a onClick={() => handleAddPopup(false)} className="btn btn-outline-danger">Close</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MembershipPackage;